import type { RealtimeEventDto } from '@shared/api/realtime/dtos/realtime-event.dto';
import type { RealtimeServerFrameDto } from '@shared/api/realtime/dtos/realtime-server-frame.dto';

export function realtimeFrameFrom(data: unknown): RealtimeServerFrameDto | null {
  if (typeof data !== 'string') {
    return null;
  }

  const frame = jsonFrom(data);

  if (!isRecord(frame)) {
    return null;
  }

  if (frame['type'] === 'ready') {
    return { type: 'ready' };
  }

  const event = frame['event'];

  if (frame['type'] !== 'event' || !isRealtimeEvent(event)) {
    return null;
  }

  return { type: 'event', event };
}

function jsonFrom(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

function isRecord(value: unknown): value is Readonly<Record<string, unknown>> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function isRealtimeEvent(value: unknown): value is RealtimeEventDto {
  if (!isRecord(value)) {
    return false;
  }

  const hasIdentity = typeof value['idEvent'] === 'string' && Number.isInteger(value['idBusiness']);
  const hasSubject = typeof value['kind'] === 'string' && typeof value['occurredAt'] === 'string';

  return hasIdentity && hasSubject && isRecord(value['body']);
}
